/**
 * ============================================================================
 * EL-ARO
 * COMPONENT: Mega Menu
 * FILE: assets/elaro-mega-menu.js
 * ============================================================================
 */

class ElaroMegaMenu {

    constructor(layer) {

        this.layer = layer;

        this.header = layer.closest(".elaro-header");

        this.menus = [

            ...this.layer.querySelectorAll("[data-mega-menu]")

        ];

        this.activeMenu = null;

        this.bindEvents();

    }

    /*==========================================================================
      Events
    ==========================================================================*/

    bindEvents() {

        document.addEventListener(

            "navigation:open",

            event => {

                this.show(event.detail.menuId);

            }

        );

        document.addEventListener(

            "navigation:close",

            () => {

                this.hide();

            }

        );

        document.addEventListener(

            "navigation:clear",

            () => {

                this.hide();

            }

        );

        this.header.addEventListener(

            "mouseleave",

            () => {

                this.hide();

            }

        );

    }

    /*==========================================================================
      Show
    ==========================================================================*/

    show(menuId) {

        if (

            this.activeMenu &&
            this.activeMenu.dataset.megaMenu === menuId

        ) {

            return;

        }

        this.hide();

        const menu = this.layer.querySelector(

            `[data-mega-menu="${menuId}"]`

        );

        if (!menu) {

            return;

        }

        menu.classList.add("is-active");

        this.activeMenu = menu;

    }

    /*==========================================================================
      Hide
    ==========================================================================*/

    hide() {

        if (!this.activeMenu) {

            return;

        }

        this.activeMenu.classList.remove("is-active");

        this.activeMenu = null;

    }

}

/*==============================================================================
  Manager
==============================================================================*/

class ElaroMegaMenuManager {

    constructor() {

        this.initialize();

    }

    initialize() {

        document

            .querySelectorAll("[data-mega-layer]")

            .forEach(layer => {

                if (

                    layer.dataset.initialized === "true"

                ) {

                    return;

                }

                new ElaroMegaMenu(layer);

                layer.dataset.initialized = "true";

            });

    }

}

/*==============================================================================
  Initialize
==============================================================================*/

const initializeMegaMenu = () => {

    new ElaroMegaMenuManager();

};

document.addEventListener(

    "DOMContentLoaded",

    initializeMegaMenu

);

document.addEventListener(

    "shopify:section:load",

    initializeMegaMenu

);